import { anchorLink } from "../include/module";
import { toggleMenu } from "../include/module";
import { msgStory } from "../include/module";
import { scrollAnim } from "../include/module";
import { loadAnim } from "../include/module";
import { preImage } from "../include/module";
import { paraNormal } from "../include/module";





(() => {

  anchorLink();
  toggleMenu();
  msgStory();
  scrollAnim();
  loadAnim();
  preImage();
  paraNormal();

})();



// WEBPACK FOOTER //
// ./src/assets/js/message/script.js